/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { func, object, number, bool, string } from 'prop-types';
import { isEmpty } from 'lodash';
// redux-utils
import { connect } from 'react-redux';
import { adminActions } from 'redux-utils/actions/index';
import { adminSelector } from 'redux-utils/selectors/index';
// components
import Typography from 'components/Typography/Typography';
// material ui
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
// utils
import { hasPermission } from '../utils';
import { PermissionsEnum } from '../enums';
// views
import DisplayPage from './DisplayPage';

const DisplayContainer = ({
  getSubPanelPageData,
  downloadAllTemplates,
  uploadReferenceImages,
  referenceImageUploadData,
  apiRequestStatus,
  pageData,
  pageTotal,
  allTemplatesData,
  stopTaskPoll,
  startTaskPoll,
  updateSidePanel,
  pollTask,
  menuProps,
  loaderStatus,
  dashboardType
}) => {
  const [
    hasDownloadedAllTemplatesFile,
    setHasDownloadedAllTemplatesFile
  ] = useState(!isEmpty(allTemplatesData));

  const [snackBarState, setSnackBarState] = useState({
    isOpen: false,
    message: '',
    duration: 4000
  });

  const handleSnackBarClose = (_e, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackBarState({
      isOpen: false,
      message: '',
      duration: 4000,
      handleClose: () => {}
    });
  };

  const getPageData = ({ offset = 0, limit = menuProps.row_limit, ...rest }) =>
    hasPermission(menuProps.permissions, PermissionsEnum.read) &&
    getSubPanelPageData({
      params: { subpanel: menuProps.name, offset, limit, ...rest }
    });

  const getSearchData = (
    col,
    searchValue,
    offset = 0,
    limit = menuProps.row_limit
  ) =>
    hasPermission(menuProps.permissions, PermissionsEnum.read) &&
    getPageData({ offset, limit, [col]: searchValue });

  useEffect(() => {
    if (
      menuProps.status !== undefined &&
      menuProps.status !== null &&
      menuProps.status.length > 0 &&
      menuProps.status.toLowerCase() === 'processing' &&
      // menuProps.status.toLowerCase() === '' &&
      !apiRequestStatus.pollTask.start &&
      !apiRequestStatus.pollTask.stop
    ) {
      startTaskPoll({
        params: { task_id: menuProps.task_id },
        other: { type: 'excelUpload', subpanel: menuProps.name }
      });
    } else {
      getPageData({});
    }
  }, [menuProps, startTaskPoll]);

  const stopPoll = type =>
    stopTaskPoll({
      params: {
        task_id: referenceImageUploadData.task_id,
        type
      }
    });

  useEffect(() => {
    if (
      apiRequestStatus.uploadReferenceImages.request &&
      apiRequestStatus.uploadReferenceImages.success &&
      !apiRequestStatus.pollTask.start
    ) {
      startTaskPoll({
        params: {
          task_id: referenceImageUploadData.task_id
        },
        other: { type: 'referenceImageUpload', subpanel: menuProps.name }
      });
    }
    return () => {};
  }, [
    apiRequestStatus.uploadReferenceImages,
    startTaskPoll,
    referenceImageUploadData
  ]);

  useEffect(() => {
    if (
      apiRequestStatus.pollTask.start &&
      (pollTask.task.type === 'packshotUpload' ||
        pollTask.task.type === 'referenceImageUpload' ||
        pollTask.task.type === 'transaction' ||
        pollTask.task.type === 'excelUpload')
    ) {
      if (apiRequestStatus.pollTask.error) {
        stopPoll(pollTask.task.type);
      }
      if (apiRequestStatus.pollTask.success) {
        if (pollTask.data.result.status.toLowerCase() !== 'pending') {
          stopPoll();
          if (
            hasPermission(menuProps.permissions, PermissionsEnum.read) &&
            pollTask.data.result.status.toLowerCase() !== 'failed'
          ) {
            getPageData({});
          }
        }
      }
    }
    return () => {};
  }, [apiRequestStatus, stopTaskPoll]);

  const handleDownloadAllTemplates = () => {
    downloadAllTemplates({ params: { subpanel: 'all' } });
    setHasDownloadedAllTemplatesFile(false);
  };

  if (!hasDownloadedAllTemplatesFile && !isEmpty(allTemplatesData)) {
    const { url } = allTemplatesData;
    if (url && url !== '') {
      const a = document.createElement('a');
      a.href = url;
      a.click();
      setHasDownloadedAllTemplatesFile(true);
    }
  }

  // show snackbar when there is no url present after user clicks on download all templates
  useEffect(() => {
    if (
      allTemplatesData &&
      !allTemplatesData.url &&
      apiRequestStatus.downloadAllTemplates.request
    ) {
      setSnackBarState({
        isOpen: true,
        message: allTemplatesData.message,
        severity: 'error',
        duration: 4000
      });
    }
  }, [allTemplatesData]);

  const getProcessingMessage = () => {
    if (
      apiRequestStatus.pollTask.start &&
      pollTask.task.type === 'excelUpload'
    ) {
      if (apiRequestStatus.pollTask.error) {
        updateSidePanel({
          params: { status: 'failed' },
          other: { subpanel: menuProps.name }
        });
        return (
          <Typography align="center" color="#f36">
            {apiRequestStatus.pollTask.message ||
              `Error happened while processing the data. Please upload the file
            again`}
          </Typography>
        );
      }
      if (apiRequestStatus.pollTask.success && pollTask.data.result) {
        if (pollTask.data.result.status.toLowerCase() === 'success') {
          updateSidePanel({
            params: { status: 'success' },
            other: { subpanel: menuProps.name }
          });
          return (
            <Typography align="center" color="#afa">
              Processed successfully
            </Typography>
          );
        }
        if (pollTask.data.result.status.toLowerCase() === 'failed') {
          updateSidePanel({
            params: { status: 'failed' },
            other: { subpanel: menuProps.name }
          });
          return (
            <Typography align="center" color="#f36">
              {pollTask.data.result.detail}
            </Typography>
          );
        }
        if (pollTask.data.result.status.toLowerCase() === 'pending') {
          return (
            <Typography align="center" color="rgba(255, 255, 255, 0.8)">
              {pollTask.data.result.detail}
            </Typography>
          );
        }
      }
      return (
        <Typography align="center" color="rgba(255, 255, 255, 0.8)">
          Processing your data. Please wait...
        </Typography>
      );
    }
    return (
      <Typography align="center" color="rgba(255, 255, 255, 0.8)">
        Processing your data. Please wait...
      </Typography>
    );
  };

  const handleReferenceImageUpload = payload => {
    const params = {
      subpanel: menuProps.name,
      ...payload
    };
    uploadReferenceImages({
      params,
      other: { type: 'promotionalStickers' }
    });
  };

  return (
    <>
      <Snackbar
        open={snackBarState.isOpen}
        autoHideDuration={snackBarState.duration}
        onClose={handleSnackBarClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
      >
        <Alert
          elevation={6}
          variant="filled"
          onClose={handleSnackBarClose}
          severity={snackBarState.severity}
        >
          {snackBarState.message}
        </Alert>
      </Snackbar>
      {hasPermission(menuProps.permissions, PermissionsEnum.read) ? (
        menuProps.status.toLowerCase() === 'processing' ? (
          <>
            <Typography>{menuProps.title}</Typography>
            {getProcessingMessage()}
          </>
        ) : (
          <DisplayPage
            pageData={pageData}
            pageTotal={pageTotal}
            getPageData={getPageData}
            getSearchData={getSearchData}
            menuProps={menuProps}
            downloadAllTemplates={handleDownloadAllTemplates}
            handleReferenceImageUpload={handleReferenceImageUpload}
            referenceImageUploadData={referenceImageUploadData}
            apiRequestStatus={apiRequestStatus}
            pollTask={pollTask}
            loaderStatus={loaderStatus}
            dashboardType={dashboardType}
          />
        )
      ) : (
        <>
          <Typography>{menuProps.title}</Typography>
          <Typography align="center" color="rgba(255,255,255,0.8)">
            {`You don't have enough permissions to view this content. Please contact
          administrator`}
          </Typography>
        </>
      )}
    </>
  );
};

DisplayContainer.propTypes = {
  getSubPanelPageData: func.isRequired,
  downloadAllTemplates: func.isRequired,
  uploadReferenceImages: func.isRequired,
  stopTaskPoll: func.isRequired,
  startTaskPoll: func.isRequired,
  updateSidePanel: func.isRequired,
  pageData: object,
  referenceImageUploadData: object,
  pageTotal: number.isRequired,
  allTemplatesData: object,
  pollTask: object,
  menuProps: object.isRequired,
  apiRequestStatus: object.isRequired,
  loaderStatus: bool.isRequired,
  dashboardType: string.isRequired
};

DisplayContainer.defaultProps = {
  pageData: undefined,
  referenceImageUploadData: {},
  allTemplatesData: undefined,
  pollTask: {}
};

const makeMapStateToProps = () => {
  const selectLoaderStatus = adminSelector.makeSelectLoaderStatus();
  const mapStateToProps = state => ({
    pageTotal: adminSelector.selectPageTotal(state),
    pageData: adminSelector.selectSubPanelPageData(state),
    stickerValues: adminSelector.selectStickerValues(state),
    allTemplatesData: adminSelector.selectDownloadAllTemplates(state),
    packshotsData: adminSelector.selectDownloadPackshots(state),
    packshotUploadData: adminSelector.selectUploadPackshot(state),
    referenceImageUploadData: adminSelector.selectReferenceImageUploadData(
      state
    ),
    excelUploadData: adminSelector.selectUploadExcel(state),
    apiRequestStatus: adminSelector.selectApiRequestStatus(state),
    transactionData: adminSelector.selectTransactionData(state),
    pollTask: adminSelector.selectPollTask(state),
    loaderStatus: selectLoaderStatus(state),
    dashboardType: state.layoutStore.routes?.dashboardConfig?.version
  });
  return mapStateToProps;
};

const mapDispatchToProps = dispatch => ({
  updateSidePanel: payload => dispatch(adminActions.updateSidePanel(payload)),
  getSubPanelPageData: payload =>
    dispatch(adminActions.getSubPanelPageData(payload)),
  downloadAllTemplates: payload =>
    dispatch(adminActions.downloadAllTemplates(payload)),
  uploadReferenceImages: payload =>
    dispatch(adminActions.uploadReferenceImagesAction(payload)),
  startTaskPoll: payload => dispatch(adminActions.startPollTaskAction(payload)),
  stopTaskPoll: payload => dispatch(adminActions.stopPollTaskAction(payload))
});

export default connect(
  makeMapStateToProps,
  mapDispatchToProps
)(DisplayContainer);
